import BannerSignup from './bannersignup.js';

export default class ToastSignup extends BannerSignup {
  getClassName() {
    return 'ToastSignup';
  }

  templateData() {
    const data = super.templateData();
    data.button_text =
      'Sign up<span class="toast-subscribe-extra-text"> for our newsletters</span>';
    // data.banner_tagline = 'We drill down on one topic in this week’s news.';
    data.banner_tagline = 'The music of mass incarceration';
    return data;
  }

  // Disable the scrolling behavior on success
  maybeScrollToTop() {}
}
